import { ClassValue, clsx } from 'clsx';

import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

function getValidHexValue(hex: string, fallback = '#000000') {
  function isValidLongHex(hex: string) {
    return /^#[0-9a-f]{6}$/i.test(hex);
  }
  function isValidShortHex(hex: string) {
    return /^#[0-9a-f]{3}$/i.test(hex);
  }

  if (isValidLongHex(hex)) return hex;
  if (isValidShortHex(hex)) return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  return fallback;
}

export function hexToHsl(h: string) {
  const hex = getValidHexValue(h);
  const [r, g, b] = hex.match(/\w\w/g)?.map((x) => parseInt(x, 16)) ?? [0, 0, 0];

  const hsl = rgbToHsl(r as number, g as number, b as number);
  return `${hsl[0]} ${hsl[1]}% ${hsl[2]}%`;
}

function rgbToHsl(r: number, g: number, b: number) {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + 6) % 6;
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h *= 60;
  }

  const hue = h.toFixed(0);
  const saturation = (s * 100).toFixed(0);
  const lightness = (l * 100).toFixed(0);

  return [hue, saturation, lightness];
}
